// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { ReCaptchaV3Provider, initializeAppCheck } from "firebase/app-check";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA84vkD6v63ItAGRi4kBpDxpQDy2MJWC0g",
    authDomain: "accessify-ce681.firebaseapp.com",
    projectId: "accessify-ce681",
    storageBucket: "accessify-ce681.firebasestorage.app",
    messagingSenderId: "347498774891",
    appId: "1:347498774891:web:e253a2075019570e9fcc2e",
    measurementId: "G-L9HSMBF3H9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Firebase Services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize App Check with reCAPTCHA v3
const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LdTQgYrAAAAAGFvlOqOGXIYXRbg6a9g7ic-K0vi"),
    isTokenAutoRefreshEnabled: true, // Auto-refresh token
});

export { db, auth, storage, appCheck };
